export const blogPosts = [
        {
            "id": "upi-scam-fake-screens",
            "category": "Threat Alerts",
            "title": "New UPI Scam Using Fake Payment Screens — Stay Alert!",
            "excerpt": "Attackers are using counterfeit payment success screens to deceive merchants. Here's how to spot and stop them.",
            "date": "2026-02-04",
            "read_time": "4 min read",
            "image": "https://images.unsplash.com/photo-1556742502-ec7c0e9f34b1?auto=format&fit=crop&w=1400&q=80",
            "content": [
                { "type": "p", "text": "A coordinated wave of UPI fraud is targeting India's small merchants. Attackers walk into shops, scan the QR, and present a screenshot of a 'Payment Successful' page that looks identical to PhonePe, GPay or Paytm — but the money never arrives." },
                { "type": "h", "text": "How the scam works" },
                { "type": "p", "text": "Fraudsters use Android screenshot apps with editable banking templates. They alter the amount, sender name and timestamp in real time, then turn the phone toward the cashier. In busy shops, cashiers rarely cross-check the bank SMS or audio confirmation." },
                { "type": "h", "text": "Five-second defence checklist" },
                {
                    "type": "ul", "items": [
                        "Listen for the merchant SoundBox audio confirmation — silence = no payment.",
                        "Always verify the SMS or in-app credit notification yourself.",
                        "Train cashiers to ignore the customer's phone screen entirely.",
                        "Enable real-time SMS alerts on the receiving account.",
                        "Report every suspicious incident on the 1930 cybercrime helpline.",
                    ]
                },
                { "type": "p", "text": "Cosmos Defence's awareness team conducts on-site merchant training across India. If your network sees recurring incidents, request a workshop via the Awareness Initiative." },
            ],
        },
        {
            "id": "phishing-email-signs",
            "category": "Scam Awareness",
            "title": "How to Identify a Phishing Email — Top 7 Key Signs",
            "excerpt": "From spoofed senders to urgency tricks — a practical checklist your whole team can use today.",
            "date": "2026-01-28",
            "read_time": "6 min read",
            "image": "https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?auto=format&fit=crop&w=1400&q=80",
            "content": [
                { "type": "p", "text": "Phishing remains the #1 root cause of breaches in India. A trained eye catches almost every attempt — these are the seven signs we drill into every Cosmos Defence awareness cohort." },
                {
                    "type": "ul", "items": [
                        "Sender domain mismatch — hover, then read every character of the email address.",
                        "Generic greetings: 'Dear Customer', 'Dear User' instead of your name.",
                        "Manufactured urgency: 'Your account will be locked in 24 hours.'",
                        "Unusual attachments — especially .html, .zip and .iso.",
                        "Requests for credentials, OTPs or banking details over email.",
                        "Subtle brand misspellings or logos that look slightly off.",
                        "Links that don't match the displayed text — always preview the URL.",
                    ]
                },
                { "type": "h", "text": "What to do if you clicked" },
                { "type": "p", "text": "Disconnect from the network, change the affected password from a different device, alert your security team, and report to 1930 if money or KYC was shared." },
            ],
        },
        {
            "id": "password-best-practices-2026",
            "category": "Enterprise Security",
            "title": "Best Practices for Password Security in 2026",
            "excerpt": "Passkeys, hardware keys, vaulting and rotation — modern guardrails for credential safety.",
            "date": "2026-01-19",
            "read_time": "5 min read",
            "image": "https://images.unsplash.com/photo-1633265486064-086b219458ec?auto=format&fit=crop&w=1400&q=80",
            "content": [
                { "type": "p", "text": "Passwords aren't dead — but the password-only era is. Modern enterprises layer passkeys, MFA and vaults to make credential theft a non-event." },
                { "type": "h", "text": "Foundations every team should adopt" },
                {
                    "type": "ul", "items": [
                        "Roll out passkeys for SaaS and internal apps wherever supported.",
                        "Mandate hardware security keys (FIDO2) for admins and finance users.",
                        "Adopt an enterprise password manager — never let credentials live in browsers.",
                        "Pair MFA with device trust (managed devices only).",
                        "Monitor for credential leakage with continuous dark-web scanning.",
                    ]
                },
                { "type": "p", "text": "Our Enterprise Security stack ships passkey-ready identity, conditional access and credential vaulting out of the box." },
            ],
        },
        {
            "id": "dpdp-act-2023",
            "category": "Compliance",
            "title": "DPDP Act 2023 — What Indian Businesses Need to Know",
            "excerpt": "A board-ready summary of obligations, data principal rights, breach reporting and penalties.",
            "date": "2026-01-09",
            "read_time": "8 min read",
            "image": "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&w=1400&q=80",
            "content": [
                { "type": "p", "text": "India's Digital Personal Data Protection Act, 2023 (DPDP) is now operational guidance for every business processing personal data. Boards are asking three questions: what changes, who is accountable, and what's the cost of getting it wrong?" },
                { "type": "h", "text": "What changes" },
                {
                    "type": "ul", "items": [
                        "Explicit, purpose-limited consent for processing personal data.",
                        "Right to access, correct and erase personal data on request.",
                        "72-hour breach notification to the Data Protection Board.",
                        "Mandatory DPO for Significant Data Fiduciaries.",
                        "Cross-border data transfer governance.",
                    ]
                },
                { "type": "h", "text": "Where Cosmos Defence helps" },
                { "type": "p", "text": "Our Compliance & GRC practice runs DPDP readiness assessments, drafts policies, builds your consent architecture, and pairs you with audit-ready evidence collection." },
            ],
        },
        {
            "id": "deepfake-detection",
            "category": "AI Security",
            "title": "Deepfake Detection: Defending the Enterprise Against Synthetic Threats",
            "excerpt": "How AI-powered detection complements user training to defuse impersonation fraud.",
            "date": "2025-12-22",
            "read_time": "7 min read",
            "image": "https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&w=1400&q=80",
            "content": [
                { "type": "p", "text": "CFO voice clones, fake-CEO video calls, synthetic KYC selfies — deepfake fraud crossed from novelty to operational threat in 2025. The defense is multi-layer." },
                {
                    "type": "ul", "items": [
                        "Process control: dual approval and out-of-band callback for any high-value transfer.",
                        "User training: a 60-second 'this could be a fake' pause for every urgent request.",
                        "Technical detection: AI models that score voice and video authenticity in real time.",
                        "Identity binding: hardware-bound credentials for sensitive actions.",
                    ]
                },
            ],
        },
        {
            "id": "senior-citizen-safety",
            "category": "Digital Safety",
            "title": "Cyber Safety Guide for Senior Citizens",
            "excerpt": "Friendly, practical scripts and family playbooks to keep elders safe from scams.",
            "date": "2025-12-12",
            "read_time": "5 min read",
            "image": "https://images.unsplash.com/photo-1573497019418-b400bb3ab074?auto=format&fit=crop&w=1400&q=80",
            "content": [
                { "type": "p", "text": "Seniors are the fastest-growing target group for cyber fraud — KYC calls, electricity bill scams, 'parcel pending' messages and fake video-call impersonations top the list." },
                { "type": "h", "text": "Family playbook (share with your parents tonight)" },
                {
                    "type": "ul", "items": [
                        "Never share OTPs — banks, electricity boards or police will never ask for one.",
                        "If someone insists on remote screen access, hang up and call back on the official number.",
                        "Save 1930 as a contact — that's the national cybercrime helpline.",
                        "Add a trusted family member as the 'second opinion' for any payment over ₹5,000.",
                        "Keep a printed list of official numbers (bank, gas, electricity) on the fridge.",
                    ]
                },
            ],
        },
        {
            "id": "qr-code-fraud",
            "category": "Scam Awareness",
            "title": "QR Code Fraud Awareness — How One Scan Drains an Account",
            "excerpt": "Static and tampered QR codes are quietly redirecting payments. Here's how to scan safely.",
            "date": "2025-11-30",
            "read_time": "4 min read",
            "image": "https://images.unsplash.com/photo-1622565862019-a4f1bb8ce5cd?auto=format&fit=crop&w=1400&q=80",
            "content": [
                { "type": "p", "text": "Scammers print sticker-thin QR overlays on petrol pumps, parking lots and merchant counters. A single scan diverts your payment — or worse, asks you to 'enter UPI PIN to receive money', which never works for receiving." },
                {
                    "type": "ul", "items": [
                        "Receiving money never requires your UPI PIN. Ever.",
                        "Verify the receiver's name in the UPI app before pressing Pay.",
                        "Be suspicious of QR codes stuck over the original printed code.",
                        "Report fraudulent merchant codes to your UPI app and 1930.",
                    ]
                },
            ],
        },
        {
            "id": "ransomware-protection",
            "category": "Enterprise Security",
            "title": "Enterprise Ransomware Protection — A Layered Playbook",
            "excerpt": "From immutable backups to rapid containment — the blueprint enterprises actually need.",
            "date": "2025-11-18",
            "read_time": "9 min read",
            "image": "https://images.unsplash.com/photo-1614064642639-e398cf05badb?auto=format&fit=crop&w=1400&q=80",
            "content": [
                { "type": "p", "text": "Ransomware payouts are down — preparation is finally winning. The pattern across customers who avoid disaster is consistent." },
                {
                    "type": "ul", "items": [
                        "Immutable, off-network backups with regular restore drills.",
                        "EDR/XDR with auto-isolation, tuned for your environment.",
                        "Privileged access management with just-in-time elevation.",
                        "Segmentation between user, server and OT networks.",
                        "A tabletop exercise every quarter — not just a written runbook.",
                    ]
                },
            ],
        },
        {
            "id": "zero-trust-explained",
            "category": "Enterprise Security",
            "title": "Zero Trust Security Explained for Indian Enterprises",
            "excerpt": "Beyond the buzzword — what Zero Trust actually means for your VPN, SaaS and contractor risk.",
            "date": "2025-11-04",
            "read_time": "7 min read",
            "image": "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1400&q=80",
            "content": [
                { "type": "p", "text": "Zero Trust is a control model, not a product. The simplest definition: never trust the network, always verify the identity, the device and the request — every time." },
                { "type": "h", "text": "Where to start" },
                {
                    "type": "ul", "items": [
                        "Replace legacy VPN with ZTNA for contractors and remote teams.",
                        "Bind access to managed devices and posture checks.",
                        "Adopt SSO + MFA with conditional access policies.",
                        "Treat SaaS apps like internal apps — same access governance.",
                    ]
                },
            ],
        },
        {
            "id": "social-media-scams",
            "category": "Digital Safety",
            "title": "Social Media Scam Awareness — From Fake Investments to Romance Fraud",
            "excerpt": "Recognise the patterns scammers reuse across Instagram, Telegram and dating apps.",
            "date": "2025-10-21",
            "read_time": "6 min read",
            "image": "https://images.unsplash.com/photo-1611162616305-c69b3fa7fbe0?auto=format&fit=crop&w=1400&q=80",
            "content": [
                { "type": "p", "text": "Social platforms have become the largest scam delivery channel in India. The script changes — the structure doesn't." },
                {
                    "type": "ul", "items": [
                        "Investment 'opportunities' that promise guaranteed returns.",
                        "WhatsApp groups with paid 'tipsters' showing manipulated screenshots.",
                        "Romance accounts that shift to crypto investment within two weeks.",
                        "Customer-care impersonation accounts under official posts.",
                    ]
                },
                { "type": "p", "text": "Train your family to never act on any investment advice that arrived through DMs." },
            ],
        },
    ];
